<template>
<div>
  <v-flex flat>
      <v-card-actions class="d-inline-flex pl-0 mb-3 cursor-pointer" @click="gotoClassTable">
        <v-icon class="mr-2 back-icon icon-primary">
          arrow_back
        </v-icon>
        <span class="title font-weight-bold blue-title font-14">Class Table</span>
      </v-card-actions>
      <v-card-actions class="d-inline-flex ml-5 mb-3 cursor-pointer blue-title font-14"  @click="noticeDialog = true">
        <v-icon slot="divider" color="#EE344C" class="pr-2">warning</v-icon>
        Important Notice
      </v-card-actions>
      <v-card-actions class="d-inline-flex  mb-3 cursor-pointer blue-title font-14"  v-if="btnVal!=0" :disabled="btnVal==2?true:false"  @click="infomationClick" :style="btnVal==2?'color:':'#D3D3D3!important'">
        <v-icon  :color="btnVal==2?'#D3D3D3':'#EE344C'" class="pr-2 " style="margin-left:-40px">mdi_email</v-icon>
        SMS To Student
      </v-card-actions>

      <v-card-actions class="d-inline-flex ml-5 mb-3 cursor-pointer blue-title font-14" @click="toKolify">
        <v-icon slot="divider" color="#fff" class="pr-2 CustomAIStoryBtn">warning</v-icon>
        <v-btn class="text-none blue-button height-28">CustomAIStory
          </v-btn>
      </v-card-actions>
     
  </v-flex>
  <v-dialog v-model="noticeDialog"
  
            max-width="1000"
            style="zIndex: 200">
        <v-card class="pa-3">
          <v-card-text>   
              <v-container grid-list-md class="pa-0">
                  <div class="blue-title font-28 font-weight-bold text-xs-center pb-3">Important Notice</div>
                  <ul class="subheading pl-0 notice-text">
                      <li>The teaching situation of teacher will be followed by the systems and the lectures will be ended automatically.The systems, however, can’t ensure every class will be ended automatically. Teachers, hence, need to click the button if the system doesn’t work.</li>
                      <li v-if="LessonStatus==0">
                        Please stay in the classroom no less than 15 minutes totally.
                        For other situations like student asked tutor to finish the class early you still have to remain inside until the class is done. Also please do not end the class ahead of time during the normal class, otherwise it will be marked as tutor’s absence automatically.
                        For absent students wait for 15 minutes secure a screen shot then you can leave the classroom.
                      </li>
                      <li>A class remark has to be filled in order to have your class time included as part of your salary.</li>
                      <li>Try to fill in a class remark within 30 minutes after your class time by selecting the “Leave Class Remarks” button.</li>
                      <li>If time doesn’t allow you to do so, it is a MUST for you to select “Submit Later” within 30 minutes after your class time, you will be able to find it back in the “Class Table” page.</li>
                      <li>If neither one action above is being taken within 30 minutes after your class time, you will no longer be able to leave a remark for the student anymore.</li>
                      <li>If a student has missed his/her class, inform the CS using the “CS Assistance” button. If a student returns after you have reported to the CS, put a checkmark next to the “Student came in late” Box and carry on with your class. If the student did not show up 25 minutes after the class time, click on “Student Absent” and no remark is needed if a class is not being attended.</li>
                  </ul>
              </v-container>
          </v-card-text>

        </v-card>
    </v-dialog>
     <!-- persistent="true"  点击模拟态是否关闭  -->
            <v-dialog
            v-model="infomationDialog"
            max-width="30%"
            style="zIndex: 200">
            <v-form ref="forms">
                <v-card class="dialog-card">
                    <v-card-title class="title blue-title pa-3 pt-4 ml-2" style="white-space:nowrap">                
                      SMS To Student
                        <div class="header-close" title="close" @click="closeInfomationDialog" ><v-icon>close</v-icon></div>
                    </v-card-title>
                    <v-card-text>   
                        <v-container pt-0 px-2 fluid>
                            <v-layout wrap>
                                <!-- <v-flex xs12>
                                    <v-flex xs12>
                                        <v-subheader class="pa-0 form-title">Select a template</v-subheader>
                                    </v-flex>
                                    <v-autocomplete single-line outline ></v-autocomplete>
                                </v-flex> -->
                                <v-flex xs12>
                                    <v-flex xs12>
                                            <v-subheader class="pa-0 form-title">Content</v-subheader>
                                        </v-flex>
                                        <!-- :value="'Dear student, please be well-prepared for our class at ' +(this.editTime(classTime))+', see you then!'" -->
                                    <v-textarea  v-model="value"  readonly   single-line   outline   no-resize  ></v-textarea> </v-flex>
                            </v-layout>
                            <v-layout row>
                              <!-- CLID 课程ID，返回值: 0-短信按钮不显示,1-短信按钮显示且可点击发送,2-短信按钮显示但置灰不可点击 -->
                                <v-flex xs12 class="text-xs-center mt-3">
                                    <v-btn class="text-none red-button dialog-submit" :disabled="submitDisabled"  @click="submitClick">Submit</v-btn>
                                    <v-btn class="text-none cancel-button" @click="closeInfomationDialog">Cancel</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                </v-card>
            </v-form><!--  -->
        </v-dialog>
</div>
</template>
<script>
import {getTrialClassSMSNoticeStatus,sendTrialClassSMSNotice} from '@/api/classtable'
import dateFileter from '@/filters/dateFilter'
import { mapGetters } from 'vuex'
import { encryption } from '@/utils/encryption'
import { getTimestamp } from '@/api/system.js'

export default {
  filters: { dateFileter },
  props: ['LessonStatus','clid','classTime','roomid'],

  data () {
    return {
      noticeDialog: false,
      infomationDialog:false,
      btnVal:0,
      value:'',
      submitDisabled:false
    }
  },
  computed: {
    ...mapGetters([ 'user' ])
  },
  async mounted(){
      this.getSmsNotice()
  },
  methods: {
    gotoClassTable(){
      this.$router.push({ path: '/classTab'  })
    },
    //关闭弹窗
    closeInfomationDialog(){
      this.infomationDialog=false;
    },
    //点击sms弹窗
    infomationClick(){
      
      let time = this.editTime(this.classTime )
      this.value=`Dear student, please be well-prepared for our class at ${time}, see you then!`
      if(this.btnVal==1){
        this.infomationDialog=true
      }
    },
    //获取smsnotice状态
    getSmsNotice(){
      var clid=this.$route.path.split('/')[2]
      getTrialClassSMSNoticeStatus(clid).then(res=>{
         this.btnVal=res 
      })
    },
    //发送Sms
    sendSmsNotice(){
      var clid=this.$route.path.split('/')[2]
      this.submitDisabled=true
      sendTrialClassSMSNotice(clid).then(res=>{
        if (res==1) {
          this.infomationDialog=false;
          this.btnVal=2
          this.$toasted.success('Send Successful!')
        }
      })
      .finally(() => {
         this.submitDisabled=false
      })
    },
    //提交
    submitClick(){
      this.sendSmsNotice()
    },
    editTime(value){
      let year = value.split('-')[0]
      console.log(value.split('-'))
      let month = value.split('-')[1]+'-'+value.split('-')[2].split('T')[0]
      let date = value.split('T')[1]
      console.log(month+'-'+year+' '+date)
      return month+'-'+year+' '+date
    },
    async toKolify(){
      // window.open(`https://kolify.com/admin/CustomAIStory?email=${this.user.email}&nick_name=${this.user.fullName}&class_id=${this.clid}`)
      let params
      let email
      if(!this.$store.state.user.account){
        email = await GetTutorAccount().then(res => {
          return res
        })
      }else{
        email = this.$store.state.user.account
      }
      let n_timestamp = await getTimestamp().then(res => {
        return res.data.Body.Timestamp || null
      })
      params = `email=${email}&nick_name=${this.user.fullName}&class_id=${this.clid}&tuid=${this.$store.state.user.tuid}&timestamp=${n_timestamp}`
      window.open(`https://kolify.com/admin/CustomAIStory?${params}&token=${encryption(params)}`)
      
    }
  }
}
</script>
<style scoped lang="scss">
.font-28{
  font-size: 28px;
}
.notice-text{
  @include font_color($font-color-theme);
  list-style: decimal;
  li{
    padding-bottom: 1rem;
  }
}
[data-theme="theme1"] .CustomAIStoryBtn{
  color: #151827!important;
}
</style>
